import { createSelector } from 'reselect';

const selectMerchantLogos = state => state.merchantLogos;

export const selectMerchantLogosConfig = createSelector(
  selectMerchantLogos,
  merchantLogos => merchantLogos.config,
);

export const selectMerchantLogosIsLoading = createSelector(
  selectMerchantLogos,
  merchantLogos => merchantLogos.isLoading,
);

export const selectMerchantLogosIsLoaded = createSelector(
  selectMerchantLogos,
  merchantLogos => merchantLogos.isLoaded,
);

export const selectMerchantLogosPlacement = createSelector(
  selectMerchantLogos,
  merchantLogos => merchantLogos.placement,
);
